import { Autocomplete } from '@mui/material'

import styled from 'styled-components'

export const AutoCompleteStyles = styled(Autocomplete)`
  width: 98%;
`
